import { useContext } from 'react';
import { FHRequestMessageContext } from 'contexts/fhrequest_message_context';

const useFHRequestMessage = () => {
    return useContext(FHRequestMessageContext);
};

export default useFHRequestMessage;
